// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Messages/Collections.proto (package time_tracking.messages.collections, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BusinessDto, BusinessLocationDto, IdentityRoleDto, IdentityUserDto, ProjectDto, TenantDto, TrackingDto, TrackingKindDto, UserWorkingTimeModelDto, WorkingTimeModelDto } from "./Basic_pb";
import { file_Messages_Basic } from "./Basic_pb";
import type { PaginationStatistics } from "./Common_pb";
import { file_Messages_Common } from "./Common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Messages/Collections.proto.
 */
export const file_Messages_Collections: GenFile = /*@__PURE__*/
  fileDesc("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", [file_Messages_Basic, file_Messages_Common]);

/**
 * Represents a collection of businesses along with pagination state.
 *
 * @generated from message time_tracking.messages.collections.BusinessCollectionDto
 */
export type BusinessCollectionDto = Message<"time_tracking.messages.collections.BusinessCollectionDto"> & {
  /**
   * The contained collection of businesses.
   *
   * @generated from field: repeated time_tracking.messages.basic.BusinessDto businesses = 1;
   */
  businesses: BusinessDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.BusinessCollectionDto.
 * Use `create(BusinessCollectionDtoSchema)` to create a new message.
 */
export const BusinessCollectionDtoSchema: GenMessage<BusinessCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 0);

/**
 * Represents a collection of business locations along with pagination state.
 *
 * @generated from message time_tracking.messages.collections.BusinessLocationCollectionDto
 */
export type BusinessLocationCollectionDto = Message<"time_tracking.messages.collections.BusinessLocationCollectionDto"> & {
  /**
   * The contained collection of business locations.
   *
   * @generated from field: repeated time_tracking.messages.basic.BusinessLocationDto business_locations = 1;
   */
  businessLocations: BusinessLocationDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.BusinessLocationCollectionDto.
 * Use `create(BusinessLocationCollectionDtoSchema)` to create a new message.
 */
export const BusinessLocationCollectionDtoSchema: GenMessage<BusinessLocationCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 1);

/**
 * Represents a collection of roles along with pagination state.
 *
 * @generated from message time_tracking.messages.collections.IdentityRoleCollectionDto
 */
export type IdentityRoleCollectionDto = Message<"time_tracking.messages.collections.IdentityRoleCollectionDto"> & {
  /**
   * The contained collection of roles.
   *
   * @generated from field: repeated time_tracking.messages.basic.IdentityRoleDto roles = 1;
   */
  roles: IdentityRoleDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.IdentityRoleCollectionDto.
 * Use `create(IdentityRoleCollectionDtoSchema)` to create a new message.
 */
export const IdentityRoleCollectionDtoSchema: GenMessage<IdentityRoleCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 2);

/**
 * Represents a collection of users along with pagination state.
 *
 * @generated from message time_tracking.messages.collections.IdentityUserCollectionDto
 */
export type IdentityUserCollectionDto = Message<"time_tracking.messages.collections.IdentityUserCollectionDto"> & {
  /**
   * The contained collection of users.
   *
   * @generated from field: repeated time_tracking.messages.basic.IdentityUserDto users = 1;
   */
  users: IdentityUserDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.IdentityUserCollectionDto.
 * Use `create(IdentityUserCollectionDtoSchema)` to create a new message.
 */
export const IdentityUserCollectionDtoSchema: GenMessage<IdentityUserCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 3);

/**
 * Represents a collection of projects where users can add trackings to.
 *
 * @generated from message time_tracking.messages.collections.ProjectCollectionDto
 */
export type ProjectCollectionDto = Message<"time_tracking.messages.collections.ProjectCollectionDto"> & {
  /**
   * The contained collection of projects.
   *
   * @generated from field: repeated time_tracking.messages.basic.ProjectDto projects = 1;
   */
  projects: ProjectDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.ProjectCollectionDto.
 * Use `create(ProjectCollectionDtoSchema)` to create a new message.
 */
export const ProjectCollectionDtoSchema: GenMessage<ProjectCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 4);

/**
 * Represents a collection of tenants of the Mogi TimeTracking application.
 *
 * @generated from message time_tracking.messages.collections.TenantCollectionDto
 */
export type TenantCollectionDto = Message<"time_tracking.messages.collections.TenantCollectionDto"> & {
  /**
   * The contained collection of tenants.
   *
   * @generated from field: repeated time_tracking.messages.basic.TenantDto tenants = 1;
   */
  tenants: TenantDto[];
};

/**
 * Describes the message time_tracking.messages.collections.TenantCollectionDto.
 * Use `create(TenantCollectionDtoSchema)` to create a new message.
 */
export const TenantCollectionDtoSchema: GenMessage<TenantCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 5);

/**
 * Represents a collection of potentially ongoing trackings over a period of time.
 *
 * @generated from message time_tracking.messages.collections.TrackingCollectionDto
 */
export type TrackingCollectionDto = Message<"time_tracking.messages.collections.TrackingCollectionDto"> & {
  /**
   * The contained collection of trackings.
   *
   * @generated from field: repeated time_tracking.messages.basic.TrackingDto trackings = 1;
   */
  trackings: TrackingDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.TrackingCollectionDto.
 * Use `create(TrackingCollectionDtoSchema)` to create a new message.
 */
export const TrackingCollectionDtoSchema: GenMessage<TrackingCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 6);

/**
 * Represents a collection of kinds of a tracking (billable, etc.).
 *
 * @generated from message time_tracking.messages.collections.TrackingKindCollectionDto
 */
export type TrackingKindCollectionDto = Message<"time_tracking.messages.collections.TrackingKindCollectionDto"> & {
  /**
   * The contained collection of tracking kinds.
   *
   * @generated from field: repeated time_tracking.messages.basic.TrackingKindDto tracking_kinds = 1;
   */
  trackingKinds: TrackingKindDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.TrackingKindCollectionDto.
 * Use `create(TrackingKindCollectionDtoSchema)` to create a new message.
 */
export const TrackingKindCollectionDtoSchema: GenMessage<TrackingKindCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 7);

/**
 * Represents a collection of user and working time model associations.
 *
 * @generated from message time_tracking.messages.collections.UserWorkingTimeModelCollectionDto
 */
export type UserWorkingTimeModelCollectionDto = Message<"time_tracking.messages.collections.UserWorkingTimeModelCollectionDto"> & {
  /**
   * The contained collection of user and working time model associations.
   *
   * @generated from field: repeated time_tracking.messages.basic.UserWorkingTimeModelDto user_working_time_models = 1;
   */
  userWorkingTimeModels: UserWorkingTimeModelDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.UserWorkingTimeModelCollectionDto.
 * Use `create(UserWorkingTimeModelCollectionDtoSchema)` to create a new message.
 */
export const UserWorkingTimeModelCollectionDtoSchema: GenMessage<UserWorkingTimeModelCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 8);

/**
 * Represents a collection of working time models.
 *
 * @generated from message time_tracking.messages.collections.WorkingTimeModelCollectionDto
 */
export type WorkingTimeModelCollectionDto = Message<"time_tracking.messages.collections.WorkingTimeModelCollectionDto"> & {
  /**
   * The contained collection of working time models.
   *
   * @generated from field: repeated time_tracking.messages.basic.WorkingTimeModelDto working_time_models = 1;
   */
  workingTimeModels: WorkingTimeModelDto[];

  /**
   * The pagination state.
   *
   * @generated from field: time_tracking.messages.common.PaginationStatistics pagination = 2;
   */
  pagination?: PaginationStatistics | undefined;
};

/**
 * Describes the message time_tracking.messages.collections.WorkingTimeModelCollectionDto.
 * Use `create(WorkingTimeModelCollectionDtoSchema)` to create a new message.
 */
export const WorkingTimeModelCollectionDtoSchema: GenMessage<WorkingTimeModelCollectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Collections, 9);

